import { api } from '@/lib/api';
import type {
  AppStatus,
  EmailLog,
  EmailTestMode,
  ListEmailLogsParams,
  ListEmailLogsResponse,
  SmtpConfigPublic,
  TestSmtpPayload,
  TestSmtpResult,
  UpdateSmtpPayload,
} from './types';

export const adminEmailApi = {
  // SMTP
  getSmtp: async (): Promise<SmtpConfigPublic | null> => {
    const { data } = await api.get<SmtpConfigPublic | null>('/admin/smtp');
    return data;
  },
  updateSmtp: async (input: UpdateSmtpPayload): Promise<SmtpConfigPublic> => {
    const { data } = await api.patch<SmtpConfigPublic>('/admin/smtp', input);
    return data;
  },
  testSmtp: async (input: TestSmtpPayload): Promise<TestSmtpResult> => {
    const { data } = await api.post<TestSmtpResult>('/admin/smtp/test', input);
    return data;
  },

  // Email Test Mode
  getEmailTestMode: async (): Promise<EmailTestMode> => {
    const { data } = await api.get<EmailTestMode>('/admin/email-test-mode');
    return data;
  },
  updateEmailTestMode: async (input: EmailTestMode): Promise<EmailTestMode> => {
    const { data } = await api.patch<EmailTestMode>(
      '/admin/email-test-mode',
      input,
    );
    return data;
  },

  // EmailLog
  listEmailLogs: async (
    params: ListEmailLogsParams = {},
  ): Promise<ListEmailLogsResponse> => {
    const { data } = await api.get<ListEmailLogsResponse>('/admin/email-logs', {
      params,
    });
    return data;
  },
  getEmailLog: async (id: string): Promise<EmailLog> => {
    const { data } = await api.get<EmailLog>(`/admin/email-logs/${id}`);
    return data;
  },

  // Banner
  getAppStatus: async (): Promise<AppStatus> => {
    const { data } = await api.get<AppStatus>('/app-status');
    return data;
  },
};
